export default "__VITE_ASSET__CDTaA1E$__"